import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../core/common/GlobalFunctions/exportTableData";
import { Drawer, message, Select } from "antd";
import { createWeekoff, fetchAllWeekoff, UpdateWeekoff, deleteWeekoff, } from "../../../core/data/redux/weekoff/weekoff.Action";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllBranch } from "../../../core/data/redux/branch/branch.Action";
import { decryptData } from "../../../core/utils/encryptUtils";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
const { Option } = Select;

type FormDataType = {
  name: string;
  branch: string;
  department: string;
  noOfDays: number;
  weekDays: string[];
  description: string;
  status: string;
  employee: any;
};

const normalizeWeekPattern = (raw: any): WeekPattern => {
  // Accepts object or JSON string or undefined; always returns a full WeekPattern
  const base = makeEmptyPattern();
  if (!raw) return base;

  let obj: any = raw;
  if (typeof raw === "string") {
    try { obj = JSON.parse(raw); } catch { return base; }
  }
  for (const d of DAYS) {
    const row = obj?.[d];
    if (!row) continue;
    const weeks = row.weeks || {};
    base[d] = {
      all: !!row.all && [1, 2, 3, 4, 5].every(k => !!weeks[k]),
      weeks: {
        1: !!weeks[1], 2: !!weeks[2], 3: !!weeks[3], 4: !!weeks[4], 5: !!weeks[5],
      }
    };
  }
  return base;
};


const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] as const;
type Day = typeof DAYS[number];

// matrix state: for each day => { all, weeks[1..5] }
type WeekPattern = Record<Day, { all: boolean; weeks: Record<1 | 2 | 3 | 4 | 5, boolean> }>;

const makeEmptyPattern = (): WeekPattern =>
  DAYS.reduce((acc, d) => {
    acc[d as Day] = { all: false, weeks: { 1: false, 2: false, 3: false, 4: false, 5: false } };
    return acc;
  }, {} as WeekPattern);

// derive distinct selected day names (used to keep your old formData.weekDays logic)
const deriveSelectedDaysFromPattern = (wp: WeekPattern): string[] =>
  DAYS.filter((d) => wp[d].all || Object.values(wp[d].weeks).some(Boolean));

const WeeklyOff = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const { departments } = useSelector((state: any) => state.department);
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const Id = selectedRowData?.weekOff_id;
  const { user } = useSelector((state: any) => state.auth);
  const { weekoff, loadingStates } = useSelector((state: any) => state.weekoff);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
  const [errors, setErrors] = useState<any>({});
  const [type, setType] = useState("");
  const { branch } = useSelector((state: any) => state.branch);
  const { employees } = useSelector((state: any) => state.employee);
  const activeEmployee = filterByStatus(employees, 'active', 'employee_status');
  const [weekPattern, setWeekPattern] = useState<WeekPattern>(makeEmptyPattern());

  const [formData, setFormData] = useState<FormDataType>({
    name: "",
    branch: "",
    department: "",
    noOfDays: 1,
    weekDays: ["Monday"],
    description: "",
    status: "",
    employee: [],
  });

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  useEffect(() => {
    setFormData((prev) => ({ ...prev, weekDays: deriveSelectedDaysFromPattern(weekPattern) }));
  }, [weekPattern]);
  const toggleAllForDay = (day: Day) => {
    setWeekPattern((prev) => {
      const next = { ...prev };
      const newVal = !prev[day].all;
      next[day] = {
        all: newVal,
        weeks: { 1: newVal, 2: newVal, 3: newVal, 4: newVal, 5: newVal },
      };
      return next;
    });
  };

  const toggleWeek = (day: Day, w: 1 | 2 | 3 | 4 | 5) => {
    setWeekPattern((prev) => {
      const next = { ...prev };
      const dayRow = { ...prev[day], weeks: { ...prev[day].weeks } };
      dayRow.weeks[w] = !dayRow.weeks[w];
      // if any week unchecked, All = false; if all 1..5 true, All = true
      const allTrue = Object.values(dayRow.weeks).every(Boolean);
      dayRow.all = allTrue;
      next[day] = dayRow;
      return next;
    });
  };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
    setErrors({});
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    setErrors({});
  };

  const handleEditDesignation = (record: any): void => {
    setSelectedRowData(record);
    setErrors({});
  };

  const handleEditSkill = (record: any): void => {
    setSelectedRowData(record);
  };

  useEffect(() => {
    if (!employees.length) {
      dispatch(getEmployees());
    }
  }, [employees.length, dispatch]);

  const handleDeleteSkill = (Id: any) => {
    const skillId = Id;
    dispatch(deleteWeekoff(skillId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          dispatch(fetchAllWeekoff());
          message.success(resp.payload.message);
          setIsDeleteModalVisible(false);
        } else {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.error);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleWeekdayToggle = (day: any) => {
    setFormData((prev): any => {
      const updatedDays = prev.weekDays.includes(day)
        ? prev.weekDays.filter((d) => d !== day)
        : [...prev.weekDays, day];

      return {
        ...prev,
        weekDays: updatedDays,
      };
    });
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "noOfDays" ? parseInt(value, 10) : value,
    }));
  };
  const validateForm = () => {
    const newErrors: any = {};

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!type) newErrors.type = "Please select a type (Branch or Department or Employee).";
    else {
      if (type === "branch" && !formData.branch) newErrors.branch = "Please select a branch.";
      if (type === "department" && !formData.department) newErrors.department = "Please select a department.";
      if (type === "employee" && (!formData.employee || formData.employee.length === 0))
        newErrors.employee = "Please select at least one employee.";
    }

    if (!formData.noOfDays || formData.noOfDays < 1 || formData.noOfDays > 7)
      newErrors.noOfDays = "Number of days must be between 1 and 7.";

    const distinctDays = deriveSelectedDaysFromPattern(weekPattern);
    if (distinctDays.length !== formData.noOfDays) {
      newErrors.weekDays = `Please select exactly ${formData.noOfDays} day(s).`;
    }

    if (!formData.description.trim()) newErrors.description = "Reason is required.";
    if (!formData.status) newErrors.status = "Status is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const distinctDays = deriveSelectedDaysFromPattern(weekPattern);


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;


    const selectedTypeId =
      type === "branch"
        ? [formData.branch]
        : type === "department"
          ? [formData.department]
          : formData.employee;

    const payload = {
      ...formData,
      type,
      weekDays: distinctDays,
      weekPattern,
      selectedTypeId,
      ...(modalType === "edit"
        ? { modifiedBy: user.UserId }
        : { createdBy: user.UserId }),
    };

    if (modalType === "edit") {
      dispatch(UpdateWeekoff({ Id: Id, data: payload })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(fetchAllWeekoff());
          handleCancel();
        } else {
          message.warning(res.payload.error);
          handleCancel();
        }
      });
    } else {
      dispatch(createWeekoff(payload)).then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(fetchAllWeekoff());
          setFormData({
            name: "",
            branch: "",
            department: "",
            noOfDays: 1,
            weekDays: ["Monday"],
            description: "",
            status: "",
            employee: [],
          });
          handleCancel();
        } else {
          message.warning(res.payload.message);
        }
      });
    }
  };

  useEffect(() => {
    dispatch(fetchAllDepartments());
    dispatch(fetchAllBranch());
    dispatch(fetchAllWeekoff());
  }, [dispatch]);

  useEffect(() => {
    if (selectedRowData) {
      const selectedType = selectedRowData.Type?.toLowerCase();
      setType(selectedType);

      let employeeIds: string[] = [];

      if (selectedType === "employee") {
        try {
          // Try to parse the AppliedTo field properly
          const parsed = JSON.parse(selectedRowData.AppliedTo);

          if (Array.isArray(parsed)) {
            employeeIds = parsed.flatMap((item: any) => {
              try {
                if (typeof item === "string" && item.startsWith("[")) {
                  // Handle nested stringified array
                  return JSON.parse(item);
                }
                return [item];
              } catch {
                return [item];
              }
            });
          }
        } catch {
          employeeIds = [];
        }
      }
      const wp = normalizeWeekPattern(selectedRowData.WeekPattern ?? selectedRowData.weekPattern);
       setWeekPattern(wp);

      setFormData({
        name: selectedRowData.Name || "",
        branch: selectedType === "branch" ? selectedRowData.AppliedTo || "" : "",
        department: selectedType === "department" ? selectedRowData.AppliedTo || "" : "",
        employee: selectedType === "employee" ? employeeIds : [],
        noOfDays: selectedRowData.Days || 1,
        weekDays: deriveSelectedDaysFromPattern(wp),
        description: selectedRowData.Description || "",
        status: selectedRowData.Status || "",
      });
    }
  }, [selectedRowData]);


  const data = weekoff ? weekoff : [];
  console.log(data , 'data')
  const exportWeeklyOff = data.map((item: any) => ({
    Name: item.Name || "N/A",
    Type: item.Type || "N/A",
    AppliedTo: item.AppliedToName || "N/A",
    Days: item.Days || "N/A",
    WeekDays: Array.isArray(item.WeekDays) ? item.WeekDays.join(", ") : item.WeekDays || "N/A",
    Description: item.Description || "N/A",
    Status: item.Status || "Inactive",
    // CreatedBy: item.CreatedBy || "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    UpdatedAt: item.UpdatedAt ? new Date(item.UpdatedAt).toLocaleDateString("en-IN") : "N/A",

  }));


  const preprocessData = (data: any[]) => {
    return data.map((item) => ({
      ...item,
      WeekDays: Array.isArray(item.WeekDays) ? item.WeekDays.join(', ') : item.WeekDays,
    }));
  };

  const processedData = preprocessData(data);


  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [dispatch, weekoff, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [weekoff, selectedStatus, selectedSort, dispatch]);

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
      render: (text: string) => <span className="fw-medium">{text}</span>,
    },
    {
      title: "Type",
      dataIndex: "Type",
      sorter: (a: any, b: any) => a.Type.localeCompare(b.Type),
      render: (text: string) => <span className="text-capitalize">{text}</span>,
    },
    {
      title: "Days",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days - b.Days,
      render: (text: number) => <span>{text}</span>,
    },
    {
      title: "Week Days",
      dataIndex: "WeekDays",
      render: (weekDays: string[]) => (
        <span>
          {weekDays && Array.isArray(weekDays) ? weekDays.join(", ") : ""}
        </span>
      ),
    },
    {
      title: "Applied To",
      dataIndex: "AppliedToName",
      render: (text: number) => <span>{text}</span>,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text?.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Button with Permission Check */}
          <button
            className="me-2"
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditDesignation(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }} data-bs-toggle="tooltip"
            data-bs-placement="top"

            title={!canEdit ? "Permission Denied" : "Edit "}
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete Button with Permission + Status Check */}
          <button
            onClick={() => {
              if (!canDelete || record.Status === "inactive") return;
              setSelectedRowData(record);
              handleEditSkill(record);
              setIsDeleteModalVisible(true);
            }}
            className="me-2"
            disabled={!canDelete || record.Status === "inactive"}
            style={{
              cursor:
                !canDelete || record.Status === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity: !canDelete || record.Status === "inactive" ? 0.5 : 1,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"

            title={
              !canDelete
                ? "Permission Denied"
                : record.Status === "inactive"
                  ? "Inactive Record"
                  : "Delete Record"
            }
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Weekly Off</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Weekly Off
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportWeeklyOff, "weeklyoff_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportWeeklyOff, "weeklyoff_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportWeeklyOff, "weeklyoff_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    onClick={() => {
                      showModal("create");
                      setFormData({
                        name: "",
                        branch: "",
                        department: "",
                        noOfDays: 1,
                        weekDays: ['Monday'],
                        description: "",
                        status: "",
                        employee: [],
                      });
                    }}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Weekly Off
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Weekly List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  {/* <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Department
                  </Link> */}
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Finance
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Application Development
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus?.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Designation */}
      <Drawer
        title={modalType === "edit" ? "Edit Weekly Off" : "Add Weekly Off"}
        placement="right"
        width={700}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              {/* Name */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.name && (
                    <div style={{ color: "red" }}>{errors.name}</div>
                  )}
                </div>
              </div>

              {/* Radio: Branch or Department */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Select Type</label>
                  <div>
                    <label className="me-3">
                      <input
                        type="radio"
                        value="branch"
                        checked={type === "branch"}
                        onChange={() => setType("branch")}
                      />{" "}
                      Branch
                    </label>

                    <label className="me-3">
                      <input
                        type="radio"
                        value="department"
                        checked={type === "department"}
                        onChange={() => setType("department")}
                      />{" "}
                      Department
                    </label>

                    <label className="">
                      <input
                        type="radio"
                        value="employee"
                        checked={type === "employee"}
                        onChange={() => setType("employee")}
                      />{" "}
                      Employee
                    </label>

                  </div>
                  {errors.type && (
                    <div style={{ color: "red" }}>{errors.type}</div>
                  )}
                </div>
              </div>

              {/* Conditional Dropdown */}
              {type === "branch" && (
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Select Branch</label>
                    <select
                      className="form-control"
                      name="branch"
                      value={formData.branch}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Branch</option>
                      {branch.map((b: any) => (
                        <option key={b.Id} value={b.Id}>
                          {b.Branch_Name}
                        </option>
                      ))}
                    </select>
                    {errors.branch && (
                      <div style={{ color: "red" }}>{errors.branch}</div>
                    )}
                  </div>
                </div>
              )}

              {type === "department" && (
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Select Department</label>
                    <select
                      className="form-control"
                      name="department"
                      value={formData.department}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Department</option>
                      {departments.map((d: any) => (
                        <option key={d.Id} value={d.Id}>
                          {d.Name}
                        </option>
                      ))}
                    </select>
                    {errors.department && (
                      <div style={{ color: "red" }}>{errors.department}</div>
                    )}
                  </div>
                </div>
              )}

              {type === "employee" && (
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Select Employee(s)</label>
                    <Select
                      mode="multiple"
                      allowClear
                      className="w-100"
                      placeholder="Select employees"
                      value={formData.employee || []}
                      onChange={(value) => {
                        setFormData((prev) => ({ ...prev, employee: value }));
                      }}
                      tagRender={(props) => {
                        const { label, closable, onClose } = props;
                        return (
                          <span
                            style={{
                              backgroundColor: '#cce5ff',
                              color: '#004085',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              marginRight: '4px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              height: '28px',
                              lineHeight: '24px',
                            }}
                          >
                            {label}
                            {closable && (
                              <span
                                style={{
                                  marginLeft: '4px',
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                }}
                                onClick={onClose}
                              >
                                ×
                              </span>
                            )}
                          </span>
                        );
                      }}
                    >
                      {activeEmployee.map((emp: any) => (
                        <Select.Option key={emp.EmployeeID} value={String(emp.EmployeeID)}>
                          {emp.Name}
                        </Select.Option>
                      ))}
                    </Select>
                    {errors.employee && (
                      <div style={{ color: "red" }}>{errors.employee}</div>
                    )}
                  </div>
                </div>
              )}

              {/* No. of Days */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    No. of Days <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    name="noOfDays"
                    min={1}
                    max={7}
                    value={formData.noOfDays}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.noOfDays && (
                    <div style={{ color: "red" }}>{errors.noOfDays}</div>
                  )}
                </div>
              </div>

              {/* Weekday Selection */}
              {/* <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Select Weekdays (Max: {formData.noOfDays})
                  </label>
                  <div className="d-flex flex-wrap gap-2">
                    {[
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday",
                    ].map((day) => (
                      <label key={day} className="me-3">
                        <input
                          type="checkbox"
                          checked={formData.weekDays.includes(day)}
                          onChange={() => handleWeekdayToggle(day)}
                        />{" "}
                        {day}
                      </label>
                    ))}
                  </div>
                  {formData.weekDays.length !== formData.noOfDays && (
                    <div style={{ color: "red" }}>
                      Please select exactly {formData.noOfDays} day(s)
                    </div>
                  )}
                </div>
              </div> */}
              {/* Weekday Selection Matrix */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Weekend definition (select by week) — Distinct days must equal {formData.noOfDays}
                  </label>

                  {/* Simple table layout; uses Bootstrap classes you already have */}
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle mb-2" style={{ minWidth: 640 }}>
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: 180 }}>Days</th>
                          <th className="text-center" style={{ width: 80 }}>All</th>
                          <th className="text-center" style={{ width: 80 }}>1st</th>
                          <th className="text-center" style={{ width: 80 }}>2nd</th>
                          <th className="text-center" style={{ width: 80 }}>3rd</th>
                          <th className="text-center" style={{ width: 80 }}>4th</th>
                          <th className="text-center" style={{ width: 80 }}>5th</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DAYS.map((day) => (
                          <tr key={day}>
                            <td className="fw-medium">{day}</td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={weekPattern[day].all}
                                onChange={() => toggleAllForDay(day)}
                              />
                            </td>
                            {[1, 2, 3, 4, 5].map((w) => (
                              <td className="text-center" key={`${day}-${w}`}>
                                <input
                                  type="checkbox"
                                  checked={weekPattern[day].weeks[w as 1 | 2 | 3 | 4 | 5]}
                                  onChange={() => toggleWeek(day, w as 1 | 2 | 3 | 4 | 5)}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* validation message: compare distinct selected days vs noOfDays */}
                  {distinctDays.length !== formData.noOfDays && (
                    <div style={{ color: "red" }}>
                      Please select exactly {formData.noOfDays} distinct day(s). Currently selected: {distinctDays.length}.
                    </div>
                  )}
                </div>
              </div>

              {/* Description */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.description && (
                    <div style={{ color: "red" }}>{errors.description}</div>
                  )}
                </div>
              </div>

              {/* Status */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  {errors.status && (
                    <div style={{ color: "red" }}>{errors.status}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={distinctDays.length !== formData.noOfDays}>
              {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit" ? "Update Weekly Off" : "Add Weekly Off"}
            </button>
          </div>
        </form>
      </Drawer>
      {/* /Add Designation */}

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.weekOff_id &&
          handleDeleteSkill(selectedRowData.weekOff_id)
        }
      />
    </>
  );
};
export default WeeklyOff;
